"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Contact = _interopRequireDefault(require("./Contact"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var ContactInfo = function ContactInfoComponent(_ref) {
  var dataClient = _ref.dataClient,
      sectionTitle = _ref.sectionTitle,
      contactList = _ref.contactList;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-tier se-tier--relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-col se-col--12 se-col--6Tablet"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "program-contact__title"
  }, dataClient.textToMarkdown(sectionTitle))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-col se-col--12 se-col--6Tablet"
  }, contactList.map(function (_ref2) {
    var contact_subtitle = _ref2.contact_subtitle,
        contact_type = _ref2.contact_type,
        contact_label = _ref2.contact_label,
        contact_link_text = _ref2.contact_link_text,
        contact_link_url = _ref2.contact_link_url;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: contact_link_url.url
    }, contact_subtitle.length > 0 && /*#__PURE__*/_react["default"].createElement("h3", {
      className: "program-contact__subtitle"
    }, dataClient.textToMarkdown(contact_subtitle)), /*#__PURE__*/_react["default"].createElement(_Contact["default"], {
      key: contact_link_url.url,
      dataClient: dataClient,
      contact_subtitle: contact_subtitle,
      contact_type: contact_type,
      contact_label: contact_label,
      contact_link_text: contact_link_text,
      contact_link_url: contact_link_url
    }));
  })))));
};

ContactInfo.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sectionTitle: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  contactList: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
var _default = ContactInfo;
exports["default"] = _default;